import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
    Alert,
    Button,
    Dialog,
    Grid,
    List, ListItem, ListItemText,
    Snackbar,
    TableBody, TableCell, TableHead, TableRow,
    Typography
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import { CustomAutocomplete } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomAutocomplete';
import { CustomCheckbox, CustomCheckboxGroup } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomGrouping';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraComparacaoValorNumerico from 'esocial.web.react.lib/cjs/components/form/Validation/RegraComparacaoValorNumerico';
import RegraExpressaoRegular from 'esocial.web.react.lib/cjs/components/form/Validation/RegraExpressaoRegular';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepRadioGroup } from 'esocial.web.react.lib/cjs/components/form/Vep/VepRadioGroup';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { CustomDialogActions, CustomDialogContent, CustomDialogTitle } from 'esocial.web.react.lib/cjs/components/util/Dialog';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import { CustomTable } from 'esocial.web.react.lib/cjs/components/util/Table';
import { TituloSecao } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useAppDispatch } from 'esocial.web.react.lib/cjs/hooks/Reduz';
import { abrirModalConfirmacao, fecharModalConfirmacao } from "esocial.web.react.lib/cjs/store/reducers/modais";
import { calcularHashDeString, getStringValue, isUndefinedOrNull, obterObjetoTodosComponentesIntocados, obterObjetoTodosComponentesTocados, obterOpcaoAutocompletePorValorVep, retornarFocoParaBotaoChamador, rolarVisualizacaoAteElemento, rolarVisualizacaoAteElementoInvalido, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useRef, useState } from 'react';
import Epis from './Epis';
import Episv_S_01_00_00Consulta from './Episv_S_01_00_00Consulta';
import Episv_S_01_01_00Consulta from './Episv_S_01_01_00Consulta';
import { obterDescricaoAgenteNocivo } from './ExposicaoRiscoRegistro';

const ButtonTextPrimary = styled(IconButton)(({ theme }) => ({
    color: theme.palette.text.primary,
}));

const ContainerBotoesTabelaAcao = styled(TableCell)(({ theme }) => ({
    '& > *': {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
}));

const ButtonsBox = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(4),
    textAlign: 'right',

    '& > *': {
        marginRight: theme.spacing(1)
    }
}));

function calcularHashItem(item) {
    return calcularHashDeString(`${item.codigo}${item.descricao}${item.tipoAvaliacao}${item.intensidadeConcentracao}${item.limiteTolerancia}${item.unidadeMedida}${item.tecnicaMedicao}${item.numeroProcessoJudicial}${item.epc.utilizacaoEPC}${item.epc.epIs}${item.epc.listaEpis}${item.epc.epiComplemento.medidaProtecao}${item.epc.epiComplemento.condicaoFuncionamento}${item.epc.epiComplemento.usoIninterrupto}${item.epc.epiComplemento.periodicidadeTroca}${item.epc.epiComplemento.prazoValidade}${item.epc.epiComplemento.higienizacao}`);
}

const chaveNovoItem = 'n';
const sufixoChaveExcluirItem = '_e';

const codigosValidacaoDescricao = ["01.01.001", "01.02.001", "01.03.001", "01.04.001", "01.05.001",
    "01.06.001", "01.07.001", "01.08.001", "01.09.001", "01.10.001",
    "01.12.001", "01.13.001", "01.14.001", "01.15.001", "01.16.001",
    "01.17.001", "01.18.001", "05.01.001"];

// 22/01/2024
const dataInicioCondicaoValidacaoNumeroProcessoJudicial = new Date(2024, 0, 22);

function AgentesNocivos(props) {
    // Trecho reservado para ajuste no retorno da modal de inserir/editar item
    const action = useRef(null);
    const ref = useRef(null);

    const [chaveActionRefAtual, setChaveActionRefAtual] = useState(null);
    // Fim de Trecho reservado para ajuste no retorno da modal de inserir/editar item

    const [habilitarEdicaoAtualizacao, setHabilitarEdicaoAtualizacao] = useState(false);
    const [habilitarInsercaoAtualizacao, setHabilitarInsercaoAtualizacao] = useState(false);
    const [habilitarVisualizacao, setHabilitarVisualizacao] = useState(false);
    const dispatch = useAppDispatch();

    function excluirItem(indice, hashExclusao) {
        const modalConfirmacaoProps = {
            texto: 'Tem certeza que deseja excluir "Agente Nocivo"?',
            textoBotaoNao: 'Não',
            textoBotaoSim: 'Sim',
            actionBotaoNao: () => {
                setChaveActionRefAtual(hashExclusao);
                retornarFocoParaBotaoChamador(action, ref);
                dispatch(fecharModalConfirmacao());
            },
            actionBotaoSim: async () => {
                props.setModelo({
                    ...props.modelo, listaAgentesNocivos: props.modelo.listaAgentesNocivos.filter((l) => l !== props.modelo.listaAgentesNocivos[indice])
                });

                // Ao excluir um item, retornar o foco ao botão de inclusão de novo item
                setChaveActionRefAtual(chaveNovoItem);
                retornarFocoParaBotaoChamador(action, ref);
            }
        };

        dispatch(abrirModalConfirmacao(modalConfirmacaoProps));
    }

    //Para o Snackbar
    const [openSnack, setOpenSnack] = useState(false);
    const [mensagemSnack, setMensagemSnack] = useState('');

    const handleCloseSnack = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenSnack(false);
    };

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['itemAgenteNocivoAuxiliar.codigo'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.descricao'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.tipoAvaliacao'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.limiteTolerancia'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.intensidadeConcentracao'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.unidadeMedida'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.tecnicaMedicao'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.numeroProcessoJudicial'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.utilizacaoEPC'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.utilizacaoEPI'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca'] = false;
    objetoComponentesTocados['itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);
    const [obrigatoriedadeLimiteTolerancia, setObrigatoriedadeLimiteTolerancia] = useState(true);
    const [obrigatoriedadeEficienciaEPC, setObrigatoriedadeEficienciaEPC] = useState(true);
    const [obrigatoriedadeEficienciaEPI, setObrigatoriedadeEficienciaEPI] = useState(true);
    const [obrigatoriedadeTipoAvaliacaoCampos, setObrigatoriedadeTipoAvaliacaoCampos] = useState(true);
    const [obrigatoriedadeIntensidadeDescricao, setObrigatoriedadeIntensidadeDescricao] = useState(true);
    const [obrigatoriedadeTipoAvaliacao, setObrigatoriedadeTipoAvaliacao] = useState(true);
    const [obrigatoriedadeNumeroProcessoJudicial, setObrigatoriedadeNumeroProcessoJudicial] = useState(true);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        setObrigatoriedadeLimiteTolerancia(props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor == '1' && (props.modelo.itemAgenteNocivoAuxiliar.codigo.valor == "01.18.001" ||
            props.modelo.itemAgenteNocivoAuxiliar.codigo.valor == "02.01.014"));

        setObrigatoriedadeEficienciaEPC(props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor == '2');
        setObrigatoriedadeEficienciaEPI(props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor == '2');
        setObrigatoriedadeTipoAvaliacaoCampos(props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor == '1');
        setObrigatoriedadeIntensidadeDescricao(codigosValidacaoDescricao.indexOf(props.modelo.itemAgenteNocivoAuxiliar.codigo.valor) >= 0);
        setObrigatoriedadeTipoAvaliacao(props.modelo.itemAgenteNocivoAuxiliar.codigo.valor != "09.01.001");
        setObrigatoriedadeNumeroProcessoJudicial(props.modelo.itemAgenteNocivoAuxiliar.codigo.valor == "05.01.001" && new Date(props.modelo.dataInicioCondicao.valor) >= dataInicioCondicaoValidacaoNumeroProcessoJudicial);

        if (props.modelo != null) {
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.codigo'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.codigo.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.codigo'] && !props.modelo.itemAgenteNocivoAuxiliar.ausenciaAgenteNocivo);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.descricao'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.descricao.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.descricao'] && obrigatoriedadeIntensidadeDescricao);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.tipoAvaliacao'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.tipoAvaliacao'] && obrigatoriedadeTipoAvaliacao);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.limiteTolerancia'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.limiteTolerancia'] && obrigatoriedadeLimiteTolerancia);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.intensidadeConcentracao'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.intensidadeConcentracao'] && obrigatoriedadeTipoAvaliacaoCampos);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.unidadeMedida'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.unidadeMedida'] && obrigatoriedadeTipoAvaliacaoCampos);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.tecnicaMedicao'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.tecnicaMedicao'] && obrigatoriedadeTipoAvaliacaoCampos);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.numeroProcessoJudicial'] = new ListaRegraValidacao([new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor, obrigatoriedadeNumeroProcessoJudicial), new RegraExpressaoRegular(props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor, '(^[0-9]{17}$)|(^[0-9]{20}$)|(^[0-9]{21}$)', true, 'O campo deve ser composto de 17, 20 ou 21 dígitos'), getStringValue(props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor).length > 0], componenteTocadoFormulario['itemAgenteNocivoAuxiliar.numeroProcessoJudicial']);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.utilizacaoEPC'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.utilizacaoEPC']);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.utilizacaoEPI'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.utilizacaoEPI']);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC'] && obrigatoriedadeEficienciaEPC);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.valor, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI'] && obrigatoriedadeEficienciaEPI);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao'] && obrigatoriedadeEficienciaEPI);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento'] && obrigatoriedadeEficienciaEPI);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto'] && obrigatoriedadeEficienciaEPI);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade'] && obrigatoriedadeEficienciaEPI);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca'] && obrigatoriedadeEficienciaEPI);
            objetoRegrasValidacao['itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao'] = new RegraObrigatoriedade(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao, componenteTocadoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao'] && obrigatoriedadeEficienciaEPI);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }
        setRegraValidacaoFormulario(objetoRegrasValidacao);

    }, [props.modelo, componenteTocadoFormulario]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

        if (regraValidacaoFormulario.todosComponentesTocados) {
            if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0) {
                if (!new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    // Aplicação de validações adicionais
                    let agenteNocivoValido = true;

                    if (props.modelo.itemAgenteNocivoAuxiliar.codigo != null && props.modelo.itemAgenteNocivoAuxiliar.codigo.valor == '09.01.001' && props.modelo.listaAgentesNocivos.length > 0) {
                        setOpenSnack(true);
                        setMensagemSnack('Não é possível cadastrar um agente nocivo com código [09.01.001], já existe(m) agente(s) nocivo(s) cadastrado(s)');
                        agenteNocivoValido = false;
                    }
                    else if (props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI != null && props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor == '2' && props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.length == 0) {
                        setOpenSnack(true);
                        setMensagemSnack('Deve ser inserido pelo menos 1 item de EPI');
                        agenteNocivoValido = false;
                    }

                    if (agenteNocivoValido) {
                        setOpenSnack(false);

                        if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'inserirItem') {
                            inserirItem();
                        }
                        else if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'editarItem') {
                            editarItem();
                        }

                        retornarFocoParaBotaoChamador(action, ref);
                    }
                }
                else {
                    rolarVisualizacaoAteElementoInvalido('fieldsetAgentesNocivos');
                }
            }

            setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
        }

    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    const habilitarEdicaoItem = () => {
        setHabilitarEdicaoAtualizacao(true);
        props.setVisibilidadeStepperButtons(false);
    };

    const habilitarVisualizacaoItem = () => {
        setHabilitarVisualizacao(true);

        if (typeof props.setVisibilidadeStepperButtons !== 'undefined') {
            props.setVisibilidadeStepperButtons(false);
        }
    };

    function cancelar() {
        setHabilitarEdicaoAtualizacao(false);
        setHabilitarInsercaoAtualizacao(false);
        setHabilitarVisualizacao(false);

        if (!isUndefinedOrNull(props) && typeof props.setVisibilidadeStepperButtons === 'function') {
            props.setVisibilidadeStepperButtons(true);
        }

        // Limpar os valores dos campos auxiliares
        props.setModelo({
            ...props.modelo,
            itemAgenteNocivoAuxiliar: {
                codigo: { ...props.modelo.itemAgenteNocivoAuxiliar.codigo, valor: '' },
                ausenciaAgenteNocivo: false,
                descricao: { ...props.modelo.itemAgenteNocivoAuxiliar.descricao, valor: null },
                tipoAvaliacao: { ...props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: null },
                limiteTolerancia: { ...props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: null },
                intensidadeConcentracao: { ...props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: null },
                unidadeMedida: { ...props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: null },
                tecnicaMedicao: { ...props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: null },
                numeroProcessoJudicial: { ...props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: null },
                epc: {
                    utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: null },
                    eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                    utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                    eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                    listaEpis: [],
                    epIs: [],
                    epiComplemento: {
                        medidaProtecao: false,
                        condicaoFuncionamento: false,
                        usoIninterrupto: false,
                        periodicidadeTroca: false,
                        prazoValidade: false,
                        higienizacao: false,
                    }
                },
            }
        });

        retornarFocoParaBotaoChamador(action, ref);
    }

    const novoItem = () => {
        if (props.modelo.listaAgentesNocivos.filter((x) => x.codigo == "09.01.001").length > 0) {
            setOpenSnack(true);
            setMensagemSnack('Não é possível informar nenhum outro código de agente nocivo quando houver o código [09.01.001]');
            return;
        }

        props.setModelo({
            ...props.modelo,
            itemAgenteNocivoAuxiliar: {
                codigo: { ...props.modelo.itemAgenteNocivoAuxiliar.codigo, valor: '' },
                ausenciaAgenteNocivo: false,
                descricao: { ...props.modelo.itemAgenteNocivoAuxiliar.descricao, valor: null },
                tipoAvaliacao: { ...props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: null },
                limiteTolerancia: { ...props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: null },
                intensidadeConcentracao: { ...props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: null },
                unidadeMedida: { ...props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: null },
                tecnicaMedicao: { ...props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: null },
                numeroProcessoJudicial: { ...props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: null },
                epc: {
                    utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: null },
                    eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                    utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                    eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                    listaEpis: [],
                    epIs: [],
                    epiComplemento: {
                        medidaProtecao: false,
                        condicaoFuncionamento: false,
                        usoIninterrupto: false,
                        periodicidadeTroca: false,
                        prazoValidade: false,
                        higienizacao: false
                    }
                },
            }
        });

        setComponenteTocadoFormulario(obterObjetoTodosComponentesIntocados(componenteTocadoFormulario));
        setHabilitarInsercaoAtualizacao(true);
        props.setVisibilidadeStepperButtons(false);

        rolarVisualizacaoAteElemento('fieldsetAgentesNocivos');

        setChaveActionRefAtual(chaveNovoItem);
    };

    function inserirItem() {
        let valorIntensidadeConcentracao = getStringValue(props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor).length > 0 ? RegraComparacaoValorNumerico._obterValorNumerico(props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor, 4) : 0;
        let valorLimiteTolerancia = getStringValue(props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor).length > 0 ? RegraComparacaoValorNumerico._obterValorNumerico(props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor, 4) : 0;

        const itemLista = {
            codigo: props.modelo.itemAgenteNocivoAuxiliar.codigo.valor,
            descricao: props.modelo.itemAgenteNocivoAuxiliar.descricao.valor,
            tipoAvaliacao: props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor,
            intensidadeConcentracao: valorIntensidadeConcentracao == 0 ? null : valorIntensidadeConcentracao,
            limiteTolerancia: valorLimiteTolerancia == 0 ? null : valorLimiteTolerancia,
            unidadeMedida: props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.valor,
            tecnicaMedicao: props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.valor,
            numeroProcessoJudicial: props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor,
            epc: {
                utilizacaoEPC: props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor,
                eficienciaProtecaoEPC: props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.valor,
                utilizacaoEPI: props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor,
                eficienciaProtecaoEPI: props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.valor,
                listaEpis: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis,
                epIs: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis,
                epiComplemento: {
                    medidaProtecao: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao ? 'S' : 'N',
                    condicaoFuncionamento: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento ? 'S' : 'N',
                    usoIninterrupto: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto ? 'S' : 'N',
                    periodicidadeTroca: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca ? 'S' : 'N',
                    prazoValidade: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade ? 'S' : 'N',
                    higienizacao: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao ? 'S' : 'N',
                }
            }
        };

        props.setModelo({
            ...props.modelo, listaAgentesNocivos: [...props.modelo.listaAgentesNocivos, itemLista],
            itemAgenteNocivoAuxiliar: {
                codigo: { ...props.modelo.itemAgenteNocivoAuxiliar.codigo, valor: '' },
                ausenciaAgenteNocivo: false,
                descricao: { ...props.modelo.itemAgenteNocivoAuxiliar.descricao, valor: null },
                tipoAvaliacao: { ...props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: null },
                limiteTolerancia: { ...props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: null },
                intensidadeConcentracao: { ...props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: null },
                unidadeMedida: { ...props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: null },
                tecnicaMedicao: { ...props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: null },
                numeroProcessoJudicial: { ...props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: null },
                epc: {
                    utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: null },
                    eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                    utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                    eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                    listaEpis: [],
                    epIs: [],
                    epiComplemento: {
                        medidaProtecao: false,
                        condicaoFuncionamento: false,
                        usoIninterrupto: false,
                        periodicidadeTroca: false,
                        prazoValidade: false,
                        higienizacao: false
                    }
                },
            }
        });

        setHabilitarInsercaoAtualizacao(false);
        props.setVisibilidadeStepperButtons(true);
    }

    function copiarItem(indice, somenteLeitura, hash) {
        if (somenteLeitura) {
            habilitarVisualizacaoItem();
        } else {
            habilitarEdicaoItem();
        }

        let itensEpi = props.modelo.listaAgentesNocivos[indice].epc.epIs;

        props.setModelo({
            ...props.modelo,
            itemAgenteNocivoAuxiliar: {
                chave: indice,
                codigo: { ...props.modelo.itemAgenteNocivoAuxiliar.codigo, valor: props.modelo.listaAgentesNocivos[indice].codigo },
                ausenciaAgenteNocivo: props.modelo.listaAgentesNocivos[indice].codigo === "09.01.001",
                descricao: { ...props.modelo.itemAgenteNocivoAuxiliar.descricao, valor: props.modelo.listaAgentesNocivos[indice].descricao },
                tipoAvaliacao: { ...props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: props.modelo.listaAgentesNocivos[indice].tipoAvaliacao },
                intensidadeConcentracao: { ...props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: props.modelo.listaAgentesNocivos[indice].intensidadeConcentracao },
                limiteTolerancia: { ...props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: props.modelo.listaAgentesNocivos[indice].limiteTolerancia },
                unidadeMedida: { ...props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: props.modelo.listaAgentesNocivos[indice].unidadeMedida },
                tecnicaMedicao: { ...props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: props.modelo.listaAgentesNocivos[indice].tecnicaMedicao },
                numeroProcessoJudicial: { ...props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: props.modelo.listaAgentesNocivos[indice].numeroProcessoJudicial },
                epc: {
                    utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: props.modelo.listaAgentesNocivos[indice].epc.utilizacaoEPC },
                    eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: props.modelo.listaAgentesNocivos[indice].epc.eficienciaProtecaoEPC },
                    utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: props.modelo.listaAgentesNocivos[indice].epc.utilizacaoEPI },
                    eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: props.modelo.listaAgentesNocivos[indice].epc.eficienciaProtecaoEPI },
                    listaEpis: itensEpi,
                    epIs: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis,
                    epiComplemento: {
                        medidaProtecao: props.modelo.listaAgentesNocivos[indice].epc.epiComplemento.medidaProtecao == 'S' ? true : false,
                        condicaoFuncionamento: props.modelo.listaAgentesNocivos[indice].epc.epiComplemento.condicaoFuncionamento == 'S' ? true : false,
                        usoIninterrupto: props.modelo.listaAgentesNocivos[indice].epc.epiComplemento.usoIninterrupto == 'S' ? true : false,
                        periodicidadeTroca: props.modelo.listaAgentesNocivos[indice].epc.epiComplemento.periodicidadeTroca == 'S' ? true : false,
                        prazoValidade: props.modelo.listaAgentesNocivos[indice].epc.epiComplemento.prazoValidade == 'S' ? true : false,
                        higienizacao: props.modelo.listaAgentesNocivos[indice].epc.epiComplemento.higienizacao == 'S' ? true : false,
                    }
                }
            }
        });

        rolarVisualizacaoAteElemento('fieldsetAgentesNocivos');

        setChaveActionRefAtual(hash);
    }

    function editarItem() {
        let valorIntensidadeConcentracao = getStringValue(props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor).length > 0 ? RegraComparacaoValorNumerico._obterValorNumerico(props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor, 4) : 0;
        let valorLimiteTolerancia = getStringValue(props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor).length > 0 ? RegraComparacaoValorNumerico._obterValorNumerico(props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor, 4) : 0;

        const itemLista = {
            codigo: props.modelo.itemAgenteNocivoAuxiliar.codigo.valor,
            descricao: props.modelo.itemAgenteNocivoAuxiliar.descricao.valor,
            tipoAvaliacao: props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor,
            intensidadeConcentracao: valorIntensidadeConcentracao == 0 ? null : valorIntensidadeConcentracao,
            limiteTolerancia: valorLimiteTolerancia == 0 ? null : valorLimiteTolerancia,
            unidadeMedida: props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.valor,
            tecnicaMedicao: props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.valor,
            numeroProcessoJudicial: props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor,
            epc: {
                utilizacaoEPC: props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor,
                eficienciaProtecaoEPC: props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.valor,
                utilizacaoEPI: props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor,
                eficienciaProtecaoEPI: props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.valor,
                epIs: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis,
                listaEpis: props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis,
                epiComplemento: {
                    medidaProtecao: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao ? 'S' : 'N',
                    condicaoFuncionamento: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento ? 'S' : 'N',
                    usoIninterrupto: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto ? 'S' : 'N',
                    periodicidadeTroca: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca ? 'S' : 'N',
                    prazoValidade: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade ? 'S' : 'N',
                    higienizacao: !isUndefinedOrNull(props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao) && props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao ? 'S' : 'N'
                }
            }
        };

        // Nesse ponto sabemos que o item pôde ser editado e chave para localização do botão com action e ref
        // de destino do foco deve ser recalculado em termos dos componentes do item
        const hash = calcularHashItem(itemLista);
        setChaveActionRefAtual(hash);

        let chaveAlteracao = props.modelo.itemAgenteNocivoAuxiliar.chave;

        props.setModelo({
            ...props.modelo, listaAgentesNocivos: [...props.modelo.listaAgentesNocivos.filter((l) => l !== props.modelo.listaAgentesNocivos[chaveAlteracao]), itemLista],
            itemAgenteNocivoAuxiliar: {
                codigo: { ...props.modelo.itemAgenteNocivoAuxiliar.codigo, valor: '' },
                ausenciaAgenteNocivo: false,
                descricao: { ...props.modelo.itemAgenteNocivoAuxiliar.descricao, valor: null },
                tipoAvaliacao: { ...props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: null },
                limiteTolerancia: { ...props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: null },
                intensidadeConcentracao: { ...props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: null },
                unidadeMedida: { ...props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: null },
                tecnicaMedicao: { ...props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: null },
                numeroProcessoJudicial: { ...props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: null },
                epc: {
                    utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: null },
                    eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                    utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                    eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                    listaEpis: [],
                    epIs: [],
                    epiComplemento: {
                        medidaProtecao: false,
                        condicaoFuncionamento: false,
                        usoIninterrupto: false,
                        periodicidadeTroca: false,
                        prazoValidade: false,
                        higienizacao: false
                    }
                },
            }
        });

        setHabilitarEdicaoAtualizacao(false);
        props.setVisibilidadeStepperButtons(true);
    }

    function atualizarItem() {
        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado(habilitarEdicaoAtualizacao ? 'editarItem' : 'inserirItem');
    }

    function handleChangeUtilizacaoEPC(e) {
        // Realizar a limpeza de alguns campos quando o valor atribuído a "epc.utilizacaoEPC" for diferente de 2 (Implementa)
        if (e.target.value == '2') {
            props.setModelo({
                ...props.modelo,
                itemAgenteNocivoAuxiliar: {
                    ...props.modelo.itemAgenteNocivoAuxiliar,
                    epc: {
                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                        utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: e.target.value }
                    }
                }
            });
        }
        else {
            props.setModelo({
                ...props.modelo,
                itemAgenteNocivoAuxiliar: {
                    ...props.modelo.itemAgenteNocivoAuxiliar,
                    epc: {
                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                        utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: e.target.value },
                        eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: null },
                        utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: null },
                        eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                        listaEpis: [],
                        epIs: [],
                        epiComplemento: {
                            medidaProtecao: false,
                            condicaoFuncionamento: false,
                            usoIninterrupto: false,
                            periodicidadeTroca: false,
                            prazoValidade: false,
                            higienizacao: false
                        }
                    },
                }
            });
        }
    }

    function handleChangeUtilizacaoEPI(e) {
        // Realizar a limpeza de alguns campos quando o valor atribuído a "epc.utilizacaoEPI" for diferente de 2 (Implementa)
        if (e.target.value == '2') {
            props.setModelo({
                ...props.modelo,
                itemAgenteNocivoAuxiliar: {
                    ...props.modelo.itemAgenteNocivoAuxiliar,
                    epc: {
                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                        utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: e.target.value }
                    }
                }
            });
        }
        else {
            props.setModelo({
                ...props.modelo,
                itemAgenteNocivoAuxiliar: {
                    ...props.modelo.itemAgenteNocivoAuxiliar,
                    epc: {
                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                        utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: e.target.value },
                        eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: null },
                        listaEpis: [],
                        epIs: [],
                        epiComplemento: {
                            medidaProtecao: false,
                            condicaoFuncionamento: false,
                            usoIninterrupto: false,
                            periodicidadeTroca: false,
                            prazoValidade: false,
                            higienizacao: false
                        }
                    },
                }
            });
        }
    }

    function handleChangeAusenciaAgenteNocivo(e) {
        props.setModelo({
            ...props.modelo,
            itemAgenteNocivoAuxiliar: {
                ...props.modelo.itemAgenteNocivoAuxiliar,
                ausenciaAgenteNocivo: e.target.checked,
                codigo: { ...props.modelo.itemAgenteNocivoAuxiliar.codigo, valor: e.target.checked ? '09.01.001' : null },
                descricao: { ...props.modelo.itemAgenteNocivoAuxiliar.descricao, valor: obterDescricaoAgenteNocivo(props.modelo.dataInicioCondicao.valor, props.modelo.itemAgenteNocivoAuxiliar.descricao.valor, e.target.checked) },
                tipoAvaliacao: { ...props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: e.target.checked ? 0 : props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor },
                limiteTolerancia: { ...props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: e.target.checked ? null : props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor },
                intensidadeConcentracao: { ...props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: e.target.checked ? null : props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor },
                unidadeMedida: { ...props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: e.target.checked ? null : props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.valor },
                tecnicaMedicao: { ...props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: e.target.checked ? null : props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.valor },
                numeroProcessoJudicial: { ...props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: e.target.checked ? null : props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor },
                epc: {
                    ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                    utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: e.target.checked ? 0 : props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor },
                    eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: e.target.checked ? null : props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.valor },
                    utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: e.target.checked ? 0 : props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor },
                    eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: e.target.checked ? null : props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.valor },
                    listaEpis: [],
                    epIs: [],
                    epiComplemento: {
                        medidaProtecao: e.target.checked ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao,
                        condicaoFuncionamento: e.target.checked ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento,
                        usoIninterrupto: e.target.checked ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto,
                        periodicidadeTroca: e.target.checked ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca,
                        prazoValidade: e.target.checked ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade,
                        higienizacao: e.target.checked ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao
                    }
                }
            }
        });
    }

    function handleChangeCodigo(e, n) {
        let ausenciaAgente = n != null && n.valor == '09.01.001';
        let informarNumeroProcesso = n != null && n.valor == '05.01.001';
        props.setModelo({
            ...props.modelo,
            itemAgenteNocivoAuxiliar: {
                ...props.modelo.itemAgenteNocivoAuxiliar,
                ausenciaAgenteNocivo: ausenciaAgente,
                codigo: { ...props.modelo.itemAgenteNocivoAuxiliar.codigo, valor: n != null ? n.valor : '' },
                descricao: { ...props.modelo.itemAgenteNocivoAuxiliar.descricao, valor: obterDescricaoAgenteNocivo(props.modelo.dataInicioCondicao.valor, props.modelo.itemAgenteNocivoAuxiliar.descricao.valor, ausenciaAgente) },
                tipoAvaliacao: { ...props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao, valor: ausenciaAgente ? null : props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor },
                limiteTolerancia: { ...props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia, valor: ausenciaAgente ? null : props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor },
                intensidadeConcentracao: { ...props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao, valor: ausenciaAgente ? null : props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor },
                unidadeMedida: { ...props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida, valor: ausenciaAgente ? null : props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.valor },
                tecnicaMedicao: { ...props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao, valor: ausenciaAgente ? null : props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.valor },
                numeroProcessoJudicial: { ...props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial, valor: (ausenciaAgente || !informarNumeroProcesso) ? null : props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor },
                epc: {
                    ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                    utilizacaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC, valor: ausenciaAgente ? 0 : props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor },
                    eficienciaProtecaoEPC: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC, valor: ausenciaAgente ? null : props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.valor },
                    utilizacaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI, valor: ausenciaAgente ? 0 : props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor },
                    eficienciaProtecaoEPI: { ...props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI, valor: ausenciaAgente ? null : props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.valor },
                    epiComplemento: {
                        medidaProtecao: ausenciaAgente ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao,
                        condicaoFuncionamento: ausenciaAgente ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento,
                        usoIninterrupto: ausenciaAgente ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto,
                        periodicidadeTroca: ausenciaAgente ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca,
                        prazoValidade: ausenciaAgente ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade,
                        higienizacao: ausenciaAgente ? false : props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao
                    }
                }
            }
        });
    }

    return (
        (props.modelo !== null && Object.values(regraValidacaoFormulario).length > 0) &&
        <Fragment>
            <Display show={(habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao) && !props.somenteVisualizacao}>
                <Fieldset
                    legend={habilitarInsercaoAtualizacao ? 'Incluir Agente Nocivo' : 'Editar Agente Nocivo'}
                    spacing={4}
                    FieldsetProps={{ id: 'fieldsetAgentesNocivos' }}
                >
                    <CustomAutocomplete
                        md={12}
                        options={props.modelo.itemAgenteNocivoAuxiliar.codigo.fonteDadosAutocomplete}
                        getOptionLabel={(option) => option.rotulo}
                        value={obterOpcaoAutocompletePorValorVep(props.modelo.itemAgenteNocivoAuxiliar.codigo.fonteDadosAutocomplete, props.modelo.itemAgenteNocivoAuxiliar.codigo.valor)}
                        onChange={(e, n) => handleChangeCodigo(e, n)}
                        readOnly={props.somenteVisualizacao}
                        disabled={props.modelo.itemAgenteNocivoAuxiliar.ausenciaAgenteNocivo}
                        inputProps={{
                            label: 'Qual o código de agente nocivo?',
                            title: props.modelo.itemAgenteNocivoAuxiliar.codigo.descricao,
                            required: !props.modelo.itemAgenteNocivoAuxiliar.ausenciaAgenteNocivo,
                            ...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.codigo'].obterPropriedadesValidacao(),
                            onBlur: () => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.codigo': true })
                        }}
                    />

                    <Grid item style={{ flexBasis: '100%' }}>
                        <CustomCheckboxGroup md={12} readOnly={props.somenteVisualizacao}>
                            <CustomCheckbox
                                label="Não existe agente nocivo ou de atividades previstas no Anexo IV do Decreto 3.048/1999"
                                checked={props.modelo.itemAgenteNocivoAuxiliar.ausenciaAgenteNocivo}
                                onChange={(e) => handleChangeAusenciaAgenteNocivo(e)}
                                readOnly={props.somenteVisualizacao}
                            />
                        </CustomCheckboxGroup>
                    </Grid>

                    <Display show={props.modelo.itemAgenteNocivoAuxiliar.codigo.valor != '09.01.001'}>
                        <VepTextField
                            accessor="itemAgenteNocivoAuxiliar.descricao"
                            label="Descreva o agente nocivo"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={12}
                            multiline
                            rows={4}
                            {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.descricao'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.descricao': true })}
                            required={obrigatoriedadeIntensidadeDescricao}
                        />

                        <VepSelect
                            accessor="itemAgenteNocivoAuxiliar.tipoAvaliacao"
                            label="Qual o tipo de avaliação?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            xs={12} md={4}
                            {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.tipoAvaliacao'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.tipoAvaliacao': true })}
                            required={obrigatoriedadeTipoAvaliacao}
                        />

                        <Display show={obrigatoriedadeTipoAvaliacaoCampos}>
                            <VepTextField
                                accessor="itemAgenteNocivoAuxiliar.intensidadeConcentracao"
                                label="Informe a intensidade, concentração ou dose da exposição do trabalhador ao fator de risco"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={8}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.intensidadeConcentracao'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.intensidadeConcentracao': true })}
                                required={obrigatoriedadeTipoAvaliacaoCampos}
                            />
                        </Display>

                        <Display show={obrigatoriedadeLimiteTolerancia}>
                            <VepTextField
                                accessor="itemAgenteNocivoAuxiliar.limiteTolerancia"
                                label="Qual o limite de tolerância calculado para agentes específicos?"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.limiteTolerancia'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.limiteTolerancia': true })}
                                required={obrigatoriedadeLimiteTolerancia}
                            />
                        </Display>

                        <Display show={obrigatoriedadeTipoAvaliacaoCampos}>
                            <VepSelect
                                accessor="itemAgenteNocivoAuxiliar.unidadeMedida"
                                label="Qual a dose ou unidade de medida da intensidade ou concentração do agente?"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.unidadeMedida'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.unidadeMedida': true })}
                                required={obrigatoriedadeTipoAvaliacaoCampos}
                            />
                        </Display>

                        <Display show={obrigatoriedadeTipoAvaliacaoCampos}>
                            <VepTextField
                                accessor="itemAgenteNocivoAuxiliar.tecnicaMedicao"
                                label="Qual a técnica utilizada para medição da intensidade ou concentração?"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.tecnicaMedicao'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.tecnicaMedicao': true })}
                                required={obrigatoriedadeTipoAvaliacaoCampos}
                            />
                        </Display>

                        <Display show={props.modelo.itemAgenteNocivoAuxiliar.codigo.valor == "05.01.001"}>
                            <VepTextField
                                accessor="itemAgenteNocivoAuxiliar.numeroProcessoJudicial"
                                label="Informe o número do processo"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={4}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.numeroProcessoJudicial'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.numeroProcessoJudicial': true })}
                                required={obrigatoriedadeNumeroProcessoJudicial}
                            />
                        </Display>

                        <Grid item style={{ flexBasis: '100%' }}>
                            <TituloSecao variant="h6" variantMapping={{ h6: 'h2' }}>Informações relativas a Equipamentos de Proteção Coletiva - EPC e Equipamentos de Proteção Individual - EPI</TituloSecao>
                        </Grid>

                        <VepSelect
                            accessor="itemAgenteNocivoAuxiliar.epc.utilizacaoEPC"
                            label="O empregador implementa medidas de proteção coletiva (EPC) para eliminar ou reduzir a exposição dos trabalhadores ao fator de risco?"
                            model={props.modelo}
                            value={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor}
                            onChange={(e) => handleChangeUtilizacaoEPC(e)}
                            xs={12} md={12}
                            {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.utilizacaoEPC'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.utilizacaoEPC': true })}
                        />

                        <Display show={obrigatoriedadeEficienciaEPC}>
                            <VepRadioGroup
                                accessor="itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC"
                                label="Os equipamento de proteção coletiva (EPCs) são eficazes na neutralização dos riscos ao trabalhador?"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC': true })}
                                required={obrigatoriedadeEficienciaEPC}
                            />
                        </Display>

                        <VepSelect
                            accessor="itemAgenteNocivoAuxiliar.epc.utilizacaoEPI"
                            label="Há utilização de equipamento individual de proteção (EPI)?"
                            model={props.modelo}
                            setModel={props.setModelo}
                            value={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor}
                            onChange={(e) => handleChangeUtilizacaoEPI(e)}
                            xs={12} md={6}
                            {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.utilizacaoEPI'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.utilizacaoEPI': true })}
                        />

                        <Display show={obrigatoriedadeEficienciaEPI}>
                            <VepRadioGroup
                                accessor="itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI"
                                label="O EPI é eficaz na neutralização do risco ao trabalhador?"
                                model={props.modelo}
                                setModel={props.setModelo}
                                xs={12} md={6}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI': true })}
                                required={obrigatoriedadeEficienciaEPI}
                            />
                        </Display>

                        <Display show={obrigatoriedadeEficienciaEPI || props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.length > 0}>
                            {/* Detail de epis*/}
                            <Grid item style={{ flexBasis: '100%' }}>
                                <Epis modelo={props.modelo} setModelo={props.setModelo} somenteVisualizacao={props.visualizacao}></Epis>
                            </Grid>
                            {/* fim Detail de epis*/}
                        </Display>

                        <Display show={obrigatoriedadeEficienciaEPI}>
                            <CustomCheckboxGroup
                                md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao': true })}
                            >
                                <CustomCheckbox
                                    label="Foram implementadas medidas de proteção coletiva, de caráter administrativo ou de organização, optando-se pelo equipamento de proteção individual (EPI) por inviabilidade técnica, insuficiência ou interinidade, ou ainda em caráter complementar ou emergencial?"
                                    checked={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao}
                                    onChange={
                                        (e) => {
                                            props.setModelo({
                                                ...props.modelo,
                                                itemAgenteNocivoAuxiliar: {
                                                    ...props.modelo.itemAgenteNocivoAuxiliar,
                                                    epc: {
                                                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                                                        epiComplemento: {
                                                            ...props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento, medidaProtecao: e.target.checked
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                />
                            </CustomCheckboxGroup>

                            <CustomCheckboxGroup
                                md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento': true })}
                            >
                                <CustomCheckbox
                                    label="Foram observadas as condições de funcionamento do equipamento de proteção individual (EPI) ao longo do tempo, conforme especificação técnica do fabricante nacional ou importador, ajustadas às condições de campo?"
                                    checked={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento}
                                    onChange={
                                        (e) => {
                                            props.setModelo({
                                                ...props.modelo,
                                                itemAgenteNocivoAuxiliar: {
                                                    ...props.modelo.itemAgenteNocivoAuxiliar,
                                                    epc: {
                                                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                                                        epiComplemento: {
                                                            ...props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento, condicaoFuncionamento: e.target.checked
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                />
                            </CustomCheckboxGroup>

                            <CustomCheckboxGroup
                                md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto': true })}
                            >
                                <CustomCheckbox
                                    label="Foi observado o uso ininterrupto do equipamento de proteção individual (EPI) ao longo do tempo, conforme especificação técnica do fabricante
									nacional ou importador, ajustadas às condições de campo?"
                                    checked={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto}
                                    onChange={
                                        (e) => {
                                            props.setModelo({
                                                ...props.modelo,
                                                itemAgenteNocivoAuxiliar: {
                                                    ...props.modelo.itemAgenteNocivoAuxiliar,
                                                    epc: {
                                                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                                                        epiComplemento: {
                                                            ...props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento, usoIninterrupto: e.target.checked
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                />
                            </CustomCheckboxGroup>

                            <CustomCheckboxGroup
                                md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade': true })}
                            >
                                <CustomCheckbox
                                    label="Foi observado o prazo de validade do Certificado de Aprovação - CA no momento da compra do equipamento de proteção individual (EPI)?"
                                    checked={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade}
                                    onChange={
                                        (e) => {
                                            props.setModelo({
                                                ...props.modelo,
                                                itemAgenteNocivoAuxiliar: {
                                                    ...props.modelo.itemAgenteNocivoAuxiliar,
                                                    epc: {
                                                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                                                        epiComplemento: {
                                                            ...props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento, prazoValidade: e.target.checked
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                />
                            </CustomCheckboxGroup>

                            <CustomCheckboxGroup
                                md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca': true })}
                            >
                                <CustomCheckbox
                                    label="É observada a periodicidade de troca definida pelo fabricante nacional ou importador e/ou programas ambientais,
			                            comprovada mediante recibo assinado pelo usuário em época própria?"
                                    checked={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca}
                                    onChange={
                                        (e) => {
                                            props.setModelo({
                                                ...props.modelo,
                                                itemAgenteNocivoAuxiliar: {
                                                    ...props.modelo.itemAgenteNocivoAuxiliar,
                                                    epc: {
                                                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                                                        epiComplemento: {
                                                            ...props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento, periodicidadeTroca: e.target.checked
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                />
                            </CustomCheckboxGroup>

                            <CustomCheckboxGroup
                                md={12}
                                {...regraValidacaoFormulario['itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao'].obterPropriedadesValidacao()}
                                onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao': true })}
                            >
                                <CustomCheckbox
                                    label="É observada a higienização conforme orientação do fabricante nacional ou importador?"
                                    checked={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao}
                                    onChange={
                                        (e) => {
                                            props.setModelo({
                                                ...props.modelo,
                                                itemAgenteNocivoAuxiliar: {
                                                    ...props.modelo.itemAgenteNocivoAuxiliar,
                                                    epc: {
                                                        ...props.modelo.itemAgenteNocivoAuxiliar.epc,
                                                        epiComplemento: {
                                                            ...props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento, higienizacao: e.target.checked
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    }
                                />
                            </CustomCheckboxGroup>
                        </Display>
                    </Display>
                </Fieldset>

                <ButtonsBox>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Cancelar
                    </Button>
                    <Button variant="text" color="primary" onClick={() => atualizarItem()}>
                        Salvar Agente Nocivo
                    </Button>
                </ButtonsBox>

                <Snackbar open={openSnack} autoHideDuration={6000} onClose={handleCloseSnack} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
                    <Alert onClose={handleCloseSnack} severity="warning">
                        {mensagemSnack}
                    </Alert>
                </Snackbar>
            </Display>

            <Display show={!habilitarInsercaoAtualizacao && !habilitarEdicaoAtualizacao}>
                <Fieldset legend="Agentes Nocivos" spacing={4}>
                    <Display show={!props.somenteVisualizacao}>
                        <Grid item style={{ flexBasis: '100%', paddingTop: '0.3rem' }}>
                            <Button color="primary"
                                startIcon={<AddIcon />}
                                onClick={() => novoItem()}
                                disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                action={chaveActionRefAtual === chaveNovoItem ? action : undefined}
                                ref={chaveActionRefAtual === chaveNovoItem ? ref : undefined}
                            >
                                Incluir Agente Nocivo
                            </Button>
                        </Grid>
                    </Display>

                    <Display show={props.modelo.listaAgentesNocivos.length > 0}>
                        <Grid item style={{ flexBasis: '100%' }}>
                            <CustomTable>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Agente Nocivo</TableCell>
                                        <TableCell align="center">Ação</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {props.modelo.listaAgentesNocivos.map((linha, indice) => {
                                        const hash = calcularHashItem(linha);
                                        const hashExclusao = `${hash}${sufixoChaveExcluirItem}`;

                                        return (
                                            <TableRow key={indice}>
                                                <TableCell align="center">{linha.codigo} - {linha.descricao}</TableCell>

                                                <ContainerBotoesTabelaAcao align="center">
                                                    <Display show={props.somenteVisualizacao}>
                                                        <ButtonTextPrimary
                                                            color="inherit"
                                                            size="small"
                                                            aria-label="visualizar item"
                                                            onClick={() => copiarItem(indice, true, hash)}
                                                            action={chaveActionRefAtual === hash ? action : undefined}
                                                            ref={chaveActionRefAtual === hash ? ref : undefined}
                                                        >
                                                            <VisibilityIcon fontSize="small" />
                                                        </ButtonTextPrimary>
                                                    </Display>
                                                    <Display show={!props.somenteVisualizacao}>
                                                        <ButtonTextPrimary
                                                            color="inherit"
                                                            size="small"
                                                            aria-label="editar item"
                                                            onClick={() => copiarItem(indice, false, hash)}
                                                            disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                            action={chaveActionRefAtual === hash ? action : undefined}
                                                            ref={chaveActionRefAtual === hash ? ref : undefined}
                                                        >
                                                            <EditIcon fontSize="small" />
                                                        </ButtonTextPrimary>
                                                        <IconButton
                                                            color="inherit"
                                                            size="small"
                                                            aria-label="excluir item"
                                                            onClick={() => excluirItem(indice, hashExclusao)}
                                                            disabled={habilitarInsercaoAtualizacao || habilitarEdicaoAtualizacao}
                                                            action={chaveActionRefAtual === hashExclusao ? action : undefined}
                                                            ref={chaveActionRefAtual === hashExclusao ? ref : undefined}
                                                        >
                                                            <DeleteIcon fontSize="small" />
                                                        </IconButton>
                                                    </Display>
                                                </ContainerBotoesTabelaAcao>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </CustomTable>
                        </Grid>
                    </Display>

                    <Display show={props.modelo.listaAgentesNocivos.length < 1}>
                        <Grid item style={{ flexBasis: '100%' }}>
                            <Typography>Nenhum agente nocivo cadastrado</Typography>
                        </Grid>
                    </Display>
                </Fieldset>
            </Display>

            {/*Modal para consulta de agente nocivo*/}
            <Dialog
                open={props.somenteVisualizacao && habilitarVisualizacao}
                onClose={() => { cancelar() }}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth={false}
            >
                <CustomDialogTitle id="form-dialog-title">Visualizar Agente Nocivo</CustomDialogTitle>
                <CustomDialogContent>
                    <div>
                        <Display show={props.modelo.itemAgenteNocivoAuxiliar.ausenciaAgenteNocivo}>
                            <Typography>Não existe agente nocivo ou de atividades previstas no Anexo IV do Decreto 3.048/1999</Typography>
                        </Display>

                        <Display show={!props.modelo.itemAgenteNocivoAuxiliar.ausenciaAgenteNocivo}>
                            <List>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.codigo != null && props.modelo.itemAgenteNocivoAuxiliar.codigo.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.codigo.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.codigo.fonteDados[props.modelo.itemAgenteNocivoAuxiliar.codigo.valor]} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.descricao != null && props.modelo.itemAgenteNocivoAuxiliar.descricao.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.descricao.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.descricao.valor} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao != null && props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.fonteDados[props.modelo.itemAgenteNocivoAuxiliar.tipoAvaliacao.valor]} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao != null && props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.intensidadeConcentracao.valor} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia != null && props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.limiteTolerancia.valor} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida != null && props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.fonteDados[props.modelo.itemAgenteNocivoAuxiliar.unidadeMedida.valor]} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao != null && props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.tecnicaMedicao.valor} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial != null && props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.numeroProcessoJudicial.valor} />
                                    </ListItem>
                                </Display>
                            </List>

                            <TituloSecao variant="h6" variantMapping={{ h6: 'h3' }}>Informações relativas a Equipamentos de Proteção Coletiva - EPC e Equipamentos de Proteção Individual - EPI</TituloSecao>

                            <List>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC != null && props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.fonteDados[props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPC.valor]} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC != null && props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.fonteDados[props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPC.valor]} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI != null && props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.fonteDados[props.modelo.itemAgenteNocivoAuxiliar.epc.utilizacaoEPI.valor]} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI != null && props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.valor != null}>
                                    <ListItem>
                                        <ListItemText primary={props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.rotulo} secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.fonteDados[props.modelo.itemAgenteNocivoAuxiliar.epc.eficienciaProtecaoEPI.valor]} />
                                    </ListItem>
                                </Display>
                            </List>

                            <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis.length > 0}>
                                <Display show={props.modelo.versao !== 'v_S_01_00_00'}>
                                    <Episv_S_01_01_00Consulta listaEpis={props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis}></Episv_S_01_01_00Consulta>
                                </Display>
                                <Display show={props.modelo.versao == 'v_S_01_00_00'}>
                                    <Episv_S_01_00_00Consulta listaEpis={props.modelo.itemAgenteNocivoAuxiliar.epc.listaEpis}></Episv_S_01_00_00Consulta>
                                </Display>
                            </Display>

                            <List>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao != null}>
                                    <ListItem>
                                        <ListItemText primary="Foram implementadas medidas de proteção coletiva, de caráter administrativo ou de organização, optando-se pelo equipamento de proteção
                            individual (EPI) por inviabilidade técnica, insuficiência ou interinidade, ou ainda em caráter complementar ou emergencial?" secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.medidaProtecao ? "Sim" : "Não"} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento != null}>
                                    <ListItem>
                                        <ListItemText primary="Foram observadas as condições de funcionamento do equipamento de proteção individual (EPI) ao longo do tempo, conforme especificação técnica
						                do fabricante nacional ou importador, ajustadas às condições de campo?" secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.condicaoFuncionamento ? "Sim" : "Não"} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto != null}>
                                    <ListItem>
                                        <ListItemText primary="Foi observado o uso ininterrupto do equipamento de proteção individual (EPI) ao longo do tempo, conforme especificação técnica do fabricante
									nacional ou importador, ajustadas às condições de campo?" secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.usoIninterrupto ? "Sim" : "Não"} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade != null}>
                                    <ListItem>
                                        <ListItemText primary="Foi observado o prazo de validade do Certificado de Aprovação - CA no momento da compra do equipamento de proteção individual (EPI)?" secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.prazoValidade ? "Sim" : "Não"} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca != null}>
                                    <ListItem>
                                        <ListItemText primary="É observada a periodicidade de troca definida pelo fabricante nacional ou importador e/ou programas ambientais,
			                            comprovada mediante recibo assinado pelo usuário em época própria?" secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.periodicidadeTroca ? "Sim" : "Não"} />
                                    </ListItem>
                                </Display>
                                <Display show={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao != null}>
                                    <ListItem>
                                        <ListItemText primary="É observada a higienização conforme orientação do fabricante nacional ou importador?" secondary={props.modelo.itemAgenteNocivoAuxiliar.epc.epiComplemento.higienizacao ? "Sim" : "Não"} />
                                    </ListItem>
                                </Display>
                            </List>
                        </Display>
                    </div>
                </CustomDialogContent>
                <CustomDialogActions>
                    <Button variant="text" color="secondary" onClick={() => cancelar()}>
                        Voltar
                    </Button>
                </CustomDialogActions>
            </Dialog>
        </Fragment >
    );
}
export default AgentesNocivos;
